import Vue from 'vue'
import Vuex from 'vuex'
import index from "./modules/index"
Vue.use(Vuex)

// 首先声明一个需要全局维护的状态 state,比如 我这里举例的resturantName
const state = {
    
}
 
// 注册上面引入的各大模块
const store = new Vuex.Store({
  modules: {
    index 
  }
})
 
export default store  // 导出store并在 main.js中引用注册。


// WEBPACK FOOTER //
// ./src/store/index.js